module.exports = __webpack_public_path__ + "img/img_card_error_02@3x.35d89c62.png";